import { computed } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  type FirestorePromptPostAssignmentType,
  empty,
} from '../firestore/PromptPostAssignmentType'

export class PromptPostAssignmentType extends ObservableModelWithDecorators<FirestorePromptPostAssignmentType> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePromptPostAssignmentType>
  ) {
    super(repository, doc)
  }

  @computed
  get title() {
    if (!this.hasData) return ''
    if (this.data.title) return this.data.title

    const id = this.id
    // turn the id into a title i.e blind_spot -> Blind Spot
    return id
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }
}
